<template>
  <div>
    <v-snackbar v-model="show" :color="color" :timeout="4000" bottom>
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="show = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      color: "",
      text: "",
      timeout: 0,
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SHOW_MESSAGE") {
        this.text = state.text;
        this.color = state.color;
        this.timeout = state.timeout;
        this.show = true;
      }
    });
  },
};
</script>

<style lang="scss">
.v-snack:not(.v-snack--absolute){
  z-index: 999999999999 !important
}
.v-snack__wrapper{
  z-index: 9999999999999 !important;
}
</style>